import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProgressSpinnerMode, ThemePalette } from '@angular/material';
import { LocalService, ManagerService, ProfileService } from 'src/app/core';
import { PopupMessageService } from 'src/app/shared/message/services/message.service';
import * as XLSX from 'xlsx';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { CONSTANTS } from 'src/app/config';
import { DataTableColumn } from 'src/app/shared/ui/data-table/data-table.component';
import { AngularEditorConfig } from '@kolkov/angular-editor';


@Component({
  selector: 'app-product-booking-challenge',
  templateUrl: './product-booking-challenge.component.html',
  styleUrls: ['./product-booking-challenge.component.scss']
})
export class ProductBookingChallengeComponent implements OnInit {

  constructor(private fb: FormBuilder, private managerService: ManagerService,
    private popupMessageService: PopupMessageService, private profileService: ProfileService) { }
  downloadExcelModalOpen = false;
  downloadExcelType = '';
  @Output() submitStatusEvent= new EventEmitter<boolean>();
  @Input() editChallengeData: any;
  fiscalYearList: any = [];
  fiscalQuarterList: any = [];
  fiscalOptionsList: any = [];
  regionsList = ["USA", "CANADA", "LATAM", "EMEAR", "APJ"];
  roleList: any = [];
  activityDropdownList: any = [];
  challengeType: any = ['Activity Challenge'];
  userProfile: any = null;
  regionCountryMapping: any = [];
  showSpinner: boolean = true;
  createNewChallengeForm!: FormGroup;
  countriesList: any = [];
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  value = 30;
  editedProductBookingData: any;
  visibilityList: any = [{label: "Seller", value: "SELLER"}, {label: "Leader", value: "LEADER"}];
  filteredOptions: Observable<any>[] = [];
  docTypeList: any = [];
  showDupsError: boolean = false;
  isActiveEdit: boolean = false;
  beGeoIdsValidationSuccess: boolean = true;

  uploadListModalOpen: boolean = false;
  uploadListDialogType: string = '';
  uploadListDialogData: any[] = [];
  uploadListPage: number = 1;
  readonly uploadListPageSize: number = 10;

  budgetSourceList = ['CONTRA', 'OPEX'];
  scmsList: any = [];
  subScmsList: any = [];
  preReqFlag='';
  preReqData:any;
  prereqActivityChallengeFlag:boolean=false;
  selectedChallengeType:any;
  readonlyFlag:boolean=false;
  ngOnInit() {
    this.getCountriesByRegion();
    this.getFiscalOptions();
    this.getAllRoles();
    this.userProfile = LocalService.get('userProfile');
    this.getdocTypeList();
    this.getAcPossibleValues();
    if(this.editChallengeData && this.editChallengeData.id){
      this.checkInactiveStatus()
    }
  }

  getAcPossibleValues() {
    this.managerService.getAcPossibleValues().subscribe((data: any) => {
      this.scmsList = data.SCMS;
      this.subScmsList = data.SUB_SCMS;
    }, (err: any) => {
      this.popupMessageService.showError('Something went wrong', 'error');
    });
  }

  createProductBookingFormForNew() {
    this.createNewChallengeForm = this.fb.group({
      activityName: ['', Validators.required],
      fiscalYear: ['', Validators.required],
      fiscalQuarter: ['', Validators.required],
      startDate: [null, Validators.required],
      endDate: [null, Validators.required],
      cutOffDate: [null, Validators.required],
      assignRegion: [[], Validators.required],
      assignRole: [[], Validators.required],
      partnerCompanies: [[]],
      minPrerequisitesToBeMet: [''],
      preRequisites: [false],
      shouldClaim: [false],
      acronym:['',Validators.required],
      description: ['', Validators.required],
      challengeRewards: [null, [Validators.required]],
      participantType: ['INDIVIDUAL', Validators.required],
      rewardType: ['POINTS', Validators.required],
      visibilityEndDate: [null],
      targetType: ['SAME_FOR_ALL_PARTICIPANTS', Validators.required],
      rewardsCap: [null, [ Validators.pattern(/^-?(0|[1-9]\d*)?$/)]],
      visibility: [[], Validators.required],
      selectallUsers:[false],
      participantGroup: this.fb.array([this.createParticipantArray()]),
      rewards: ['',Validators.required],
      countryList: [[]],
      proofofCompletion: [false],
      budgetSource: ['', Validators.required],
      budgetCapByRegionGroup: this.fb.array([]),
      manualDescription: [''],
      eligibleScms: [[]],
      eligibleSubScms: [[]]
    });
    this.applyDateControlsDisabledState();
  };

  setIdentifier() {
    let acronym = "AC-" + 'PRDBKNG';
 
    let challengeName = '';
    if (this.createNewChallengeForm.value.fiscalYear && this.createNewChallengeForm.value.fiscalQuarter.length > 0) {
      let periodStartData = this.fiscalOptionsList.filter((x: any) => x.fiscalYear == this.createNewChallengeForm.value.fiscalYear
        && x.fiscalQuarter == this.createNewChallengeForm.value.fiscalQuarter[0])[0]
      let periodEndData = this.fiscalOptionsList.filter((x: any) => x.fiscalYear == this.createNewChallengeForm.value.fiscalYear
         && x.fiscalQuarter == this.createNewChallengeForm.value.fiscalQuarter[this.createNewChallengeForm.value.fiscalQuarter.length - 1])[0]
      const sd = new Date(periodStartData.startDate);
      const ed = new Date(periodEndData.endDate);
      const startDate = new Date(sd.getUTCFullYear(), sd.getUTCMonth(), sd.getUTCDate());
      const endDate = new Date(ed.getUTCFullYear(), ed.getUTCMonth(), ed.getUTCDate());

      this.createNewChallengeForm.controls.startDate.setValue(startDate);
      this.createNewChallengeForm.controls.endDate.setValue(endDate);
    }

    if (this.createNewChallengeForm.value.activityName) {
      this.createNewChallengeForm.value.activityName.split(" ").filter((e: any)=>e.trim()).forEach((x: any) => {
        challengeName += x.charAt(0).toUpperCase();
      });
    }
    let yearVal;
    if (this.createNewChallengeForm.value.fiscalYear) {
      yearVal = this.createNewChallengeForm.value.fiscalYear;
    }
    let quarterVal;
    if (this.createNewChallengeForm.value.fiscalQuarter) {
      quarterVal = this.createNewChallengeForm.value.fiscalQuarter[this.createNewChallengeForm.value.fiscalQuarter.length - 1];
    }
    if (challengeName) {
      acronym = acronym + '-' + challengeName
    }
    if (quarterVal) {
      acronym = acronym + '-' + quarterVal
    }
    if (yearVal) {
      acronym = acronym + yearVal
    }
    this.createNewChallengeForm.controls.acronym.setValue(acronym);
  }

  getFiscalOptions() {
    this.managerService.getActivityFiscalOptions().subscribe((data: any) => {
      data.forEach((element: any) => {
        element.startDate=new Date(element.startDate).toISOString()
        element.endDate=new Date(element.endDate).toISOString()
      });
      this.fiscalOptionsList = data;
      this.fiscalYearList = Array.from(new Set(data.map((x: any) => x.fiscalYear)));
      this.fiscalQuarterList = Array.from(new Set(data.map((x: any) => x.fiscalQuarter)));
    }, (_err: any) => {
      this.popupMessageService.showError('Something went wrong', 'error');
    });
  };

  setCountryListByRegion() {
    let dropdownData: any[] = [];
    this.regionCountryMapping.forEach((regionData: any) => {
      this.createNewChallengeForm.value.assignRegion.forEach((region: any) => {
        if (region === regionData.region) {
          dropdownData = [...dropdownData, ...regionData]
        }
      })
    })
    this.countriesList = dropdownData
    let selectedCountries: any[] = []
    this.createNewChallengeForm.value.countryList.forEach((country: any) => {
      if (this.createNewChallengeForm.value.assignRegion.includes(dropdownData.filter((x: any) =>
        x.countryCode === country.countryCode)[0] && dropdownData.filter((x: any) =>
        x.countryCode === country.countryCode)[0].region
      )) {
        selectedCountries = [...selectedCountries, ...country]
      }
    })
    this.createNewChallengeForm.controls.countryList.setValue(selectedCountries)
    this.onRegionSelection();
  };

  getCountriesByRegion() {
    this.managerService.getCountryListByRegion(this.regionsList).subscribe((data: any) => {
      this.regionCountryMapping = data
      if (this.editChallengeData && this.editChallengeData.id) {
        this.editedProductBookingData = this.editChallengeData;
        this.updateFormWithChallengeData();
      } else if (this.editChallengeData && this.editChallengeData.isClone) {
        this.editedProductBookingData = this.editChallengeData;
        this.updateFormWithChallengeData();
      } else {
        this.showSpinner = false;
        this.createProductBookingFormForNew();
      }
    }, (_err: any) => {
      this.popupMessageService.showError('Something went wrong', 'error');
    })
  };

  updateFormWithChallengeData() {
    this.createNewChallengeForm = this.fb.group({
      activityName: [this.editedProductBookingData.name, Validators.required],
      fiscalYear: [this.editedProductBookingData.fiscalYear, Validators.required],
      fiscalQuarter: [this.editedProductBookingData.fiscalQuarters, Validators.required],
      startDate: [new Date(this.editedProductBookingData.startDate), Validators.required],
      endDate: [new Date(this.editedProductBookingData.completeBy), Validators.required],
      cutOffDate: [new Date(this.editedProductBookingData.cutoffDate), Validators.required],
      assignRegion: [this.editedProductBookingData.regions, Validators.required],
      assignRole: this.editedProductBookingData.participantType === 'INDIVIDUAL' ? [this.editedProductBookingData.roleIds, Validators.required] : [null],
      partnerCompanies: [this.editedProductBookingData.beGeoIds],
      acronym:[this.editedProductBookingData.acronym,Validators.required],
      description: [this.editedProductBookingData.description, Validators.required],
      challengeRewards: [this.editedProductBookingData.challengeRewards, [Validators.required]],
      selectallUsers:[this.roleList.length === this.editedProductBookingData.roleIds.length],
      rewards: this.editedProductBookingData.rewardType === 'MANUAL' ? [null] : [(this.editedProductBookingData.credits || this.editedProductBookingData.points), [Validators.required]],
      participantGroup: this.fb.array(this.updateParticipantArray(this.editedProductBookingData.productsBookingActChPgList)),
      participantType: [this.editedProductBookingData.participantType, Validators.required],
      countryList: [this.getCountryList()],
      rewardType: [this.editedProductBookingData.rewardType, Validators.required],
      visibilityEndDate: [this.editedProductBookingData.visibilityEndDate ? new Date(this.editedProductBookingData.visibilityEndDate) : null],
      targetType: [this.editedProductBookingData.targetType, Validators.required],
      preRequisites: this.editedProductBookingData.requiredPrerequisites,
      shouldClaim: [this.editedProductBookingData.shouldClaim],
      minPrerequisitesToBeMet: [this.editedProductBookingData.minimumNumberOfPrerequisitesToBeMet],
      rewardsCap: [this.editedProductBookingData.winnersCount > 0 ? this.editedProductBookingData.winnersCount : null, [ Validators.pattern(/^-?(0|[1-9]\d*)?$/)]],
      visibility: [this.editedProductBookingData.visibilities, Validators.required],
      proofofCompletion: [this.editedProductBookingData.requiredUploadDocuments],
      budgetSource: this.editedProductBookingData.budgetSource,
      budgetCapByRegionGroup: this.fb.array(this.setBudgetCapData(this.editedProductBookingData)),
      manualDescription: [this.editedProductBookingData.manualDescription],
      eligibleScms: [this.editedProductBookingData.scms || []],
      eligibleSubScms: [this.editedProductBookingData.subScms || []]
    });
    if (this.editedProductBookingData.requiredUploadDocuments) {
      this.createNewChallengeForm.addControl('proofOfCompletionGroup', this.fb.array(this.updateProofOfCompletionArray(this.editedProductBookingData.documents)))
      this.editedProductBookingData.documents.forEach((_: any, index: number) => this.manageFilteredOptionsList(index))
    };
    if(this.editedProductBookingData.requiredPrerequisites && this.editedProductBookingData.prerequisitesDTO.length){
      this.preReqData=this.editedProductBookingData.prerequisitesDTO;
      this.createNewChallengeForm.addControl('preRequisitesGroup', this.fb.array(this.updatePreRequisites(this.editedProductBookingData.prerequisitesDTO)))
      this.setChallengeDropdownData(this.editedProductBookingData.prerequisitesDTO)
    };
    this.isActiveEdit = !this.editedProductBookingData.isClone && this.editedProductBookingData.status === 'ACTIVE';
    this.showSpinner = false;
    this.onRewardTypeChange();
    this.applyDateControlsDisabledState();
  };

  updateParticipantArray(participantArray: any[]) {
    let participantArrayGroup: any[] = []
    participantArray.forEach((participant: any) => {
      participantArrayGroup.push(this.fb.group({
        id: [participant.id],
        paticipantGroupName: [participant.name, [Validators.required]],
        minNoOfTargets: [participant.minimumNumberOfTargetsToBeAchieved, [Validators.required]],
        participantIds: [participant.participantBeGeoIds.length > 0 ? participant.participantBeGeoIds : participant.participantUserIds, Validators.required],
        addTargetGroup: this.fb.array(this.updateTargetGroupArray(participant.productsBookingActChTargetList)),
        deleted: [false]
      }));
    })
    return participantArrayGroup
  };

  updateTargetGroupArray(targetGroupList: any[]) {
    let updatedTargetList: any[] = []
    let targetType = this.editedProductBookingData.targetType
    targetGroupList.forEach((target: any) => {
      if (targetType === 'SAME_FOR_ALL_PARTICIPANTS') {
        updatedTargetList.push(this.fb.group({
          id: [target.id],
          targetGroupName: [target.name, [Validators.required]],
          eligibleProductSkus: [target.productSkus],
          eligibleProductSkusNotApplicable: [target.productSkus.length === 0],
          eligibleProductFamilies: [target.productFamilies],
          eligibleProductFamiliesNotApplicable: [target.productFamilies.length === 0],
          setTargets: [null],
          minTargets: [target.targetBooking, [Validators.required]],
          isOptional: [target.optional],
          deleted: [false]
        }, { validator: this.skuOrFamilyDataRequired}))
      } else {
        updatedTargetList.push(this.fb.group({
          id: [target.id],
          targetGroupName: [target.name, [Validators.required]],
          eligibleProductSkus: [target.productSkus],
          eligibleProductSkusNotApplicable: [target.productSkus.length === 0],
          eligibleProductFamilies: [target.productFamilies],
          eligibleProductFamiliesNotApplicable: [target.productFamilies.length === 0],
          setTargets: [this.setTargetData(target.participantTargets), [Validators.required]],
          minTargets: [null],
          isOptional: [target.optional],
          deleted: [false]
        }, { validator: this.skuOrFamilyDataRequired}))
      }
    })
    return updatedTargetList
  };

  setTargetData(targetData: any[]) {
    return targetData.map((x: any) => {
      return {
          participantId: Number(x.beGeoId) || Number(x.userId),
          target: x.targetBooking
      }
    })
  };

  getCountryList() {
    let dropdownData: any[] = []
    let selectedCountries: any[] = []
    this.regionCountryMapping.forEach((regionData: any) => {
      this.editedProductBookingData.regions.forEach((region: any) => {
        if (region === regionData.region) {
          dropdownData = [...dropdownData, ...regionData]
        }
      })
    })
    this.countriesList = dropdownData;
    selectedCountries = this.countriesList.filter((country: any) => this.editedProductBookingData.countries.includes(country.countryCode));
    return selectedCountries;
  };

  getAllRoles() {
    this.profileService.getAllRoles().subscribe((data: any) => {
      if (data) {
        this.roleList = data;
      }
    })
  };

  onRewardTypeChange() {
    let rewardType = this.createNewChallengeForm.controls.rewardType.value;
    if (rewardType === 'MANUAL') {
      this.createNewChallengeForm.get('rewards')!.setValue(null);
      this.createNewChallengeForm.get('rewards')!.clearValidators();
      this.createNewChallengeForm.get('rewards')!.updateValueAndValidity();

      this.createNewChallengeForm.get('manualDescription')!.setValue(this.editedProductBookingData ? this.editedProductBookingData.manualDescription : '');
      this.createNewChallengeForm.get('manualDescription')!.setValidators([Validators.required]);
      this.createNewChallengeForm.get('manualDescription')!.updateValueAndValidity();
    } else {
      this.createNewChallengeForm.get('rewards')!.setValue(this.editedProductBookingData ? (this.editedProductBookingData.credits || this.editedProductBookingData.points) : '');
      this.createNewChallengeForm.get('rewards')!.setValidators([Validators.required]);
      this.createNewChallengeForm.get('rewards')!.updateValueAndValidity();

      this.createNewChallengeForm.get('manualDescription')!.setValue(null);
      this.createNewChallengeForm.get('manualDescription')!.clearValidators();
      this.createNewChallengeForm.get('manualDescription')!.updateValueAndValidity();
    }
    this.onRegionSelection();
  };

  onParticipantTypeChange() {
    let participantType = this.createNewChallengeForm.controls.participantType.value;
    if (participantType === 'INDIVIDUAL') {
      this.createNewChallengeForm.get('assignRole')!.setValue([]);
      this.createNewChallengeForm.get('assignRole')!.setValidators([Validators.required]);
      this.createNewChallengeForm.get('assignRole')!.updateValueAndValidity();
    } else {
      this.createNewChallengeForm.get('assignRole')!.setValue(null);
      this.createNewChallengeForm.get('assignRole')!.clearValidators();
      this.createNewChallengeForm.get('assignRole')!.updateValueAndValidity();
    };
  };

  getSelectedVisibilityItems(): any[] {
    const values: any[] = this.createNewChallengeForm.get('visibility')!.value || [];
    return this.visibilityList.filter((item: any) => values.indexOf(item.value) > -1);
  }

  onVisibilitySelectionChange(items: any[]): void {
    this.createNewChallengeForm.get('visibility')!.setValue(items.map((item: any) => item.value));
  }

  getSelectedRoleItems(): any[] {
    const values: any[] = this.createNewChallengeForm.get('assignRole')!.value || [];
    return this.roleList.filter((role: any) => values.indexOf(role.id) > -1);
  }

  onRoleSelectionChange(items: any[]): void {
    this.createNewChallengeForm.get('assignRole')!.setValue(items.map((item: any) => item.id));
  }

  onTargetTypeChange() {
    let targetType = this.createNewChallengeForm.controls.targetType.value
    if (targetType === 'SAME_FOR_ALL_PARTICIPANTS') {
      this.createNewChallengeForm.controls.participantGroup.value.forEach((_group: any, index: number) => {
        this.createNewChallengeForm.controls.participantGroup.value[index].addTargetGroup.forEach((_targetGroup: any, tarIndex: number) => {
          const targetControls = (this.createNewChallengeForm.get('participantGroup') as any)['controls'][index]
            .get('addTargetGroup').controls[tarIndex];
          targetControls.get('setTargets').setValue(null)
          targetControls.get('setTargets').clearValidators()
          targetControls.get('setTargets').updateValueAndValidity()

          targetControls.get('minTargets').setValue("")
          targetControls.get('minTargets').setValidators([Validators.required])
          targetControls.get('minTargets').updateValueAndValidity()
        })
      })
    } else {
      this.createNewChallengeForm.controls.participantGroup.value.forEach((_group: any, index: number) => {
        this.createNewChallengeForm.controls.participantGroup.value[index].addTargetGroup.forEach((_targetGroup: any, tarIndex: number) => {
          const targetControls = (this.createNewChallengeForm.get('participantGroup') as any)['controls'][index]
            .get('addTargetGroup').controls[tarIndex];
          targetControls.get('setTargets').setValue([])
          targetControls.get('setTargets').setValidators([], [Validators.required])
          targetControls.get('setTargets').updateValueAndValidity()

          targetControls.get('minTargets').setValue(null)
          targetControls.get('minTargets').clearValidators()
          targetControls.get('minTargets').updateValueAndValidity()
        })
      })
    }
  }

  toggleAllSelection(): void {
    const assignRoleControl = this.createNewChallengeForm.get('assignRole');
    if (!assignRoleControl) { return; }
    if (this.createNewChallengeForm.get('selectallUsers')!.value) {
      assignRoleControl.setValue(this.roleList.map((role: any) => role.id));
    } else {
      assignRoleControl.setValue([]);
    }
  };

  optionClick(): void {
    const assignRoleControl = this.createNewChallengeForm.get('assignRole');
    const selectedCount = assignRoleControl ? (assignRoleControl.value || []).length : 0;
    this.createNewChallengeForm.patchValue({
      selectallUsers: selectedCount === this.roleList.length
    });
  };


  onPartnerCompaniesFileSelected(rows: any[]) {
    if (!rows || rows.length === 0) {
      this.popupMessageService.showError('The uploaded file is empty', 'error');
      return;
    }
    const columnsName = Object.keys(rows[0]);
    const list: string[] = rows.map((val: any) => val[columnsName[0]].toString());
    this.createNewChallengeForm.controls.partnerCompanies.setValue(list);
  }

  onParticipantIdsFileSelected(rows: any[], parentIndex: number) {
    if (!rows || rows.length === 0) {
      this.popupMessageService.showError('The uploaded file is empty', 'error');
      return;
    }
    const columnsName = Object.keys(rows[0]);
    const list: string[] = rows.map((val: any) => val[columnsName[0]].toString());
    (this.createNewChallengeForm.controls.participantGroup as any)['controls'][parentIndex].controls.participantIds.setValue(list);
  }

  onProductSkusFileSelected(rows: any[], parentIndex: number, targetIndex: number) {
    if (!rows || rows.length === 0) {
      this.popupMessageService.showError('The uploaded file is empty', 'error');
      return;
    }
    const columnsName = Object.keys(rows[0]);
    const list: string[] = rows.map((val: any) => val[columnsName[0]].toString());
    (this.createNewChallengeForm.controls.participantGroup as any)['controls'][parentIndex]
      .controls.addTargetGroup.controls[targetIndex].controls.eligibleProductSkus.setValue(list);
  }

  onProductFamiliesFileSelected(rows: any[], parentIndex: number, targetIndex: number) {
    if (!rows || rows.length === 0) {
      this.popupMessageService.showError('The uploaded file is empty', 'error');
      return;
    }
    const columnsName = Object.keys(rows[0]);
    const list: string[] = rows.map((val: any) => val[columnsName[0]].toString());
    (this.createNewChallengeForm.controls.participantGroup as any)['controls'][parentIndex]
      .controls.addTargetGroup.controls[targetIndex].controls.eligibleProductFamilies.setValue(list);
  }

  onSetTargetsFileSelected(rows: any[], parentIndex: number, targetIndex: number) {
    if (!rows || rows.length === 0) {
      this.popupMessageService.showError('The uploaded file is empty', 'error');
      return;
    }
    const columnsName = Object.keys(rows[0]);
    const list = rows.map((val: any) => ({
      participantId: val[columnsName[0]].toString(),
      target: val[columnsName[1]].toFixed(0).toString()
    }));
    (this.createNewChallengeForm.controls.participantGroup as any)['controls'][parentIndex]
      .controls.addTargetGroup.controls[targetIndex].controls.setTargets.setValue(list);
  }

  partnerCompaniesClear() {
    this.createNewChallengeForm.controls.partnerCompanies.setValue([]);
  };

  participantIdsClear(parentIndex: number) {
    (this.createNewChallengeForm.controls.participantGroup as any)['controls'][parentIndex!].controls.participantIds.setValue([]);
  };

  productSkusClear(parentIndex: number, targetIndex: number) {
    (this.createNewChallengeForm.controls.participantGroup as any)['controls'][parentIndex!]
      .controls.addTargetGroup.controls[targetIndex!].controls.eligibleProductSkus.setValue([]);
  };

  productFamiliesClear(parentIndex: number, targetIndex: number) {
    (this.createNewChallengeForm.controls.participantGroup as any)['controls'][parentIndex!]
      .controls.addTargetGroup.controls[targetIndex!].controls.eligibleProductFamilies.setValue([]);
  };

  setTargetsClear(parentIndex: number, targetIndex: number) {
    (this.createNewChallengeForm.controls.participantGroup as any)['controls'][parentIndex!]
      .controls.addTargetGroup.controls[targetIndex!].controls.setTargets.setValue([]);
  };

  showDownloadExcelFormatDialog(excelType: string): void {
    if (excelType === 'TARGETS') {
      if (this.createNewChallengeForm.value.participantType === 'INDIVIDUAL') {
        excelType = 'TARGETS_INDIVIDUAL';
      } else {
        excelType = 'TARGETS_COMPANY';
      }
    }
    if (excelType === 'PARTICIPANTIDS') {
      if (this.createNewChallengeForm.value.participantType === 'INDIVIDUAL') {
        excelType = 'PARTICIPANT_INDIVIDUAL';
      } else {
        excelType = 'PARTICIPANT_COMPANY';
      }
    }
    this.downloadExcelType = excelType;
    this.downloadExcelModalOpen = true;
  }

  closeDownloadExcelModal(): void {
    this.downloadExcelModalOpen = false;
  }

  downloadExcel(): void {
    let columnData = [];
    if (this.downloadExcelType === 'BEGEOID') {
      columnData = [['BEGEOID']];
    } else if (this.downloadExcelType === 'END_CUSTOMER_ID') {
      columnData = [['END CUSTOMER GLOBAL HQ ID']];
    } else if (this.downloadExcelType === 'INDIVIDUAL_PRODUCT_LIST') {
      columnData = [['PRODUCT', 'TYPE', 'PAYOUT']];
    } else if (this.downloadExcelType === 'PRODUCT_LIST') {
      columnData = [['PRODUCT']];
    } else if (this.downloadExcelType === 'EXCEL_MERGE') {
      columnData = [['PRODUCT', 'TYPE']];
    } else if (this.downloadExcelType === 'PRODUCT_SKUS') {
      columnData = [['PRODUCT SKUS']];
    } else if (this.downloadExcelType === 'PRODUCT_FAMILIES') {
      columnData = [['PRODUCT FAMILIES']];
    } else if (this.downloadExcelType === 'TARGETS_INDIVIDUAL') {
      columnData = [['USER', 'TARGET']];
    } else if (this.downloadExcelType === 'TARGETS_COMPANY') {
      columnData = [['BEGEOID', 'TARGET']];
    } else if (this.downloadExcelType === 'PARTICIPANT_INDIVIDUAL') {
      columnData = [['USERIDS']];
    } else if (this.downloadExcelType === 'PARTICIPANT_COMPANY') {
      columnData = [['BEGEOIDS']];
    } else if (this.downloadExcelType === 'UPLOAD_COMPLETION') {
      columnData = [['CCOID', 'Date of completion (MM/DD/YYYY)']];
    } else {
      return;
    }
    let workbook = XLSX.utils.book_new(),
      worksheet = XLSX.utils.aoa_to_sheet(columnData);
    workbook.SheetNames.push('First');
    workbook.Sheets['First'] = worksheet;
    let xlsbin = XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' });
    let buffer = new ArrayBuffer(xlsbin.length),
      array = new Uint8Array(buffer);
    for (let i = 0; i < xlsbin.length; i++) {
      array[i] = xlsbin.charCodeAt(i) & 0xff;
    }
    let xlsblob = new Blob([buffer], { type: 'application/octet-stream' });
    let url = window.URL.createObjectURL(xlsblob),
      anchor = document.createElement('a');
    anchor.href = url;
    if (this.downloadExcelType === 'BEGEOID') {
      anchor.download = 'BEGEOID_LIST.xlsx';
    } else if (this.downloadExcelType === 'END_CUSTOMER_ID') {
      anchor.download = 'END_CUSTOMER_LIST.xlsx';
    } else if (this.downloadExcelType === 'INDIVIDUAL_PRODUCT_LIST') {
      anchor.download = 'PRODUCT_PAYOUTS.xlsx';
    } else if (this.downloadExcelType === 'PRODUCT_LIST') {
      anchor.download = 'PRODUCT_LIST.xlsx';
    } else if (this.downloadExcelType === 'EXCEL_MERGE') {
      anchor.download = 'PRODUCT_LIST_ANY_PRODUCT.xlsx';
    } else if (this.downloadExcelType === 'PRODUCT_SKUS') {
      anchor.download = 'PRODUCT_SKUS.xlsx';
    } else if (this.downloadExcelType === 'PRODUCT_FAMILIES') {
      anchor.download = 'PRODUCT_FAMILIES.xlsx';
    } else if (this.downloadExcelType === 'TARGETS_INDIVIDUAL') {
      anchor.download = 'TARGETS_INDIVIDUAL.xlsx';
    } else if (this.downloadExcelType === 'TARGETS_COMPANY') {
      anchor.download = 'TARGETS_COMPANY.xlsx';
    } else if (this.downloadExcelType === 'PARTICIPANT_INDIVIDUAL') {
      anchor.download = 'PARTICIPANT_INDIVIDUAL.xlsx';
    } else if (this.downloadExcelType === 'PARTICIPANT_COMPANY') {
      anchor.download = 'PARTICIPANT_COMPANY.xlsx';
    } else if (this.downloadExcelType === 'UPLOAD_COMPLETION') {
      anchor.download = 'Participation Challenge Completions Upload.xlsx';
    }
    anchor.click();
    window.URL.revokeObjectURL(url);
  }

  openProductDialogContent(dialogType: string, index: number, groupIndex?: number) {
    if (dialogType === 'PARTICIPANTIDS') {
      dialogType = this.createNewChallengeForm.value.participantType === 'INDIVIDUAL' ? 'PARTICIPANT_INDIVIDUAL' : 'PARTICIPANT_COMPANY';
    }
    this.uploadListDialogType = dialogType;
    const participantControl = (this.createNewChallengeForm.controls.participantGroup as any)['controls'][index];
    if (dialogType === 'BEGEOID') {
      this.uploadListDialogData = this.createNewChallengeForm.controls.partnerCompanies.value;
    } else if (dialogType === 'PRODUCT_SKUS') {
      this.uploadListDialogData = participantControl.controls.addTargetGroup.controls[groupIndex!].controls.eligibleProductSkus.value;
    } else if (dialogType === 'PRODUCT_FAMILIES') {
      this.uploadListDialogData = participantControl.controls.addTargetGroup.controls[groupIndex!].controls.eligibleProductFamilies.value;
    } else if (dialogType === 'SET_TARGETS') {
      this.uploadListDialogData = participantControl.controls.addTargetGroup.controls[groupIndex!].controls.setTargets.value;
    } else if (dialogType === 'PARTICIPANT_INDIVIDUAL' || dialogType === 'PARTICIPANT_COMPANY') {
      this.uploadListDialogData = participantControl.controls.participantIds.value;
    }
    this.uploadListModalOpen = true;
  };

  get uploadListModalTitle(): string {
    if (this.uploadListDialogType === 'PRODUCT_SKUS') { return 'Eligible Product SKUs'; }
    if (this.uploadListDialogType === 'PRODUCT_FAMILIES') { return 'Eligible Product Families'; }
    if (this.uploadListDialogType === 'BEGEOID' || this.uploadListDialogType === 'PARTICIPANT_COMPANY') { return 'Eligible BegeoId List'; }
    if (this.uploadListDialogType === 'SET_TARGETS') { return 'Eligible Targets List'; }
    if (this.uploadListDialogType === 'PARTICIPANT_INDIVIDUAL') { return 'Eligible Users Ids'; }
    return '';
  }

  get uploadListColumns(): DataTableColumn[] {
    if (this.uploadListDialogType === 'SET_TARGETS') {
      return [
        { field: 'participantId', header: 'Participant Id' },
        { field: 'target', header: 'Target' }
      ];
    }
    let header = '';
    if (this.uploadListDialogType === 'PRODUCT_SKUS') { header = 'Product SKUs'; }
    else if (this.uploadListDialogType === 'PRODUCT_FAMILIES') { header = 'Product Families'; }
    else if (this.uploadListDialogType === 'BEGEOID' || this.uploadListDialogType === 'PARTICIPANT_COMPANY') { header = 'BeGeoId'; }
    else if (this.uploadListDialogType === 'PARTICIPANT_INDIVIDUAL') { header = 'User Ids'; }
    return [{ field: 'value', header }];
  }

  get uploadListRows(): any[] {
    const start = (this.uploadListPage - 1) * this.uploadListPageSize;
    const slice = this.uploadListDialogData.slice(start, start + this.uploadListPageSize);
    if (this.uploadListDialogType === 'SET_TARGETS') { return slice; }
    return slice.map((item: any) => ({ value: item }));
  }

  onUploadListPageChange(page: number): void {
    this.uploadListPage = page;
  }

  closeUploadListModal(): void {
    this.uploadListModalOpen = false;
    this.uploadListDialogType = '';
    this.uploadListDialogData = [];
    this.uploadListPage = 1;
  };

  onPreRequisitesChange(value: boolean) {
    const preReqControl = this.createNewChallengeForm.get('preRequisites');
    if (preReqControl) { preReqControl.setValue(value); }
    if (value) {
      const startDate = this.createNewChallengeForm.getRawValue().startDate;
      const endDate = this.createNewChallengeForm.getRawValue().endDate;
      const regions = this.createNewChallengeForm.value.assignRegion;
      const participantType = this.createNewChallengeForm.value.participantType;
      if (!startDate || !endDate || !regions || regions.length === 0 || !participantType) {
        this.preReqFlag = 'Note: To mention any prerequisites make sure you provide start date, end date, regions and participant type';
      } else {
        this.preReqFlag = '';
      }
      this.createNewChallengeForm.addControl('preRequisitesGroup', this.fb.array([this.createPreRequisitesArray()]))
    } else {
      this.preReqFlag = ''
      this.createNewChallengeForm.removeControl('preRequisitesGroup')
      this.activityDropdownList = []
    }
  };

  createPreRequisitesArray() {
    return this.fb.group({
      challengeType: ["", Validators.required],
      activityChallenge: ["", Validators.required],
      isOptional: [false, Validators.required]
    })
  };

  getParticipantList(form: any) {
    return form.controls.participantGroup.controls;
  };

  getRequisitesList(form: any) {
    return form.controls.preRequisitesGroup.controls;
  };

  getParticipantTargetsList(form: any, index: number) {
    return form.controls.participantGroup.controls[index].controls.addTargetGroup.controls
  };

  onChallengeTypeChange(event: any, index: number) {
     this.selectedChallengeType = (this.createNewChallengeForm.controls.preRequisitesGroup as any)['controls'][index].value.challengeType;
    const rawStart = this.createNewChallengeForm.getRawValue().startDate;
    const rawEnd = this.createNewChallengeForm.getRawValue().endDate;
    const sd = rawStart ? new Date(rawStart) : null;
    const ed = rawEnd ? new Date(rawEnd) : null;
    let startDate: any = sd
      ? `${sd.getFullYear()}-${String(sd.getMonth() + 1).padStart(2, '0')}-${String(sd.getDate()).padStart(2, '0')}`
      : null;
    let endDate: any = ed
      ? `${ed.getFullYear()}-${String(ed.getMonth() + 1).padStart(2, '0')}-${String(ed.getDate()).padStart(2, '0')}`
      : null;
    let regions = this.createNewChallengeForm.value.assignRegion;
    if (this.selectedChallengeType && startDate && endDate && regions) {
      if (this.selectedChallengeType === 'Activity Challenge') {
        const participantType = this.createNewChallengeForm.value.participantType;
        this.managerService.getActivityData(startDate, endDate, regions, participantType).subscribe((data: any)=>{
          this.activityDropdownList[index] = data.ACTIVITY_CHALLENGES;
          if(this.editChallengeData){
            this.activityDropdownList[index]=  data.ACTIVITY_CHALLENGES.filter((x: any)=>{ return x.id!=this.editChallengeData.id})
            let checkDropdownValueExist=this.activityDropdownList[index].some(
              (item: any)=>item.id === this.preReqData[index].preqActivityChallengeId
            )
            if(!checkDropdownValueExist){
              this.preReqData[index].id=this.preReqData[index].preqActivityChallengeId;
              this.activityDropdownList[index].push(this.preReqData[index])
            }
           }
        }, (_err: any) => {
          this.popupMessageService.showError('Something went wrong', 'error');
        })
      }
      if (this.selectedChallengeType === 'Leaderboard Challenge') {
        this.activityDropdownList[index] = []
      }
    } else {
      this.activityDropdownList[index] = [];
    }
  };

  addPreRequisitesGroup() {
    const control = <FormArray>this.createNewChallengeForm.get('preRequisitesGroup');
    control.push(this.createPreRequisitesArray());
  };

  removePreRequisitesGroup(index: number) {
    const control = <FormArray>this.createNewChallengeForm.get('preRequisitesGroup');
    control.removeAt(index)
  };

  createParticipantArray() {
    let participationFormGroup;
    let rewardType = this.createNewChallengeForm ? this.createNewChallengeForm.controls.rewardType.value : 'POINTS'
    if (rewardType === 'MANUAL') {
      participationFormGroup = this.fb.group({
        id: [null],
        paticipantGroupName: ["", [Validators.required]],
        minNoOfTargets: ["", [Validators.required]],
        participantIds: [[], Validators.required],
        addTargetGroup: this.fb.array([this.createTargetGroupArray()]),
        deleted: [false]
      });
    } else {
      participationFormGroup = this.fb.group({
        id: [null],
        paticipantGroupName: ["", [Validators.required]],
        minNoOfTargets: ["", [Validators.required]],
        participantIds: [[], Validators.required],
        addTargetGroup: this.fb.array([this.createTargetGroupArray()]),
        deleted: [false]
      });
    }
    return participationFormGroup
  };

  createTargetGroupArray() {
    let targetType = this.createNewChallengeForm ? this.createNewChallengeForm.controls.targetType.value : 'SAME_FOR_ALL_PARTICIPANTS'
    if (targetType === 'SAME_FOR_ALL_PARTICIPANTS') {
      return this.fb.group({
        id: [null],
        targetGroupName: ["", [Validators.required]],
        eligibleProductSkus: [[]],
        eligibleProductSkusNotApplicable: [false],
        eligibleProductFamilies: [[]],
        eligibleProductFamiliesNotApplicable: [false],
        setTargets: [null],
        minTargets: ["", [Validators.required]],
        isOptional: [false],
        deleted: [false]
      }, { validator: this.skuOrFamilyDataRequired});
    } else {
      return this.fb.group({
        id: [null],
        targetGroupName: ["", [Validators.required]],
        eligibleProductSkus: [[]],
        eligibleProductSkusNotApplicable: [false],
        eligibleProductFamilies: [[]],
        eligibleProductFamiliesNotApplicable: [false],
        setTargets: [[], [Validators.required]],
        minTargets: [null],
        isOptional: [false],
        deleted: [false]
      }, { validator: this.skuOrFamilyDataRequired});
    }
  };

  skuOrFamilyDataRequired(group : FormGroup) : {[s:string ]: boolean} | null {
    if (group) {
      if(group.controls['eligibleProductSkus'].value.length > 0 
      || group.controls['eligibleProductFamilies'].value.length > 0
      || group.controls['eligibleProductSkusNotApplicable'].value
      || group.controls['eligibleProductFamiliesNotApplicable'].value) {
        return null;
      }
    }
    return {'error': true};
  };

  removeParticipantBlock(index: number) {
    const control = <FormArray>this.createNewChallengeForm.get('participantGroup');
    const pgList = this.editChallengeData ? this.editChallengeData.productsBookingActChPgList : null;
    if (pgList && pgList[index] && pgList[index].id) {
      const deletedControl = control.at(index).get('deleted');
      if (deletedControl) {
        deletedControl.setValue(true);
      }
    } else {
      control.removeAt(index);
    }
  };

  cloneParticipantBlock(index: number) {
    const control = <FormArray>this.createNewChallengeForm.get('participantGroup');
    const duplicate = this.duplicateParticipantData(index);
    control.push(duplicate);
  };

  duplicateParticipantData(index: number) {
    let participationFormGroup;
    participationFormGroup = this.fb.group({
      id: [null],
      paticipantGroupName: [this.createNewChallengeForm.value.participantGroup[index].paticipantGroupName, [Validators.required]],
      minNoOfTargets: [this.createNewChallengeForm.value.participantGroup[index].minNoOfTargets, [Validators.required]],
      participantIds: [this.createNewChallengeForm.value.participantGroup[index].participantIds, Validators.required],
      addTargetGroup: this.fb.array(this.duplicateTargetGroupArray(index)),
      deleted: [false]
    });
    return participationFormGroup
  };

  duplicateTargetGroupArray(index: number) {
    let targetGroupArray: FormGroup[] = []
    let targetType = this.createNewChallengeForm ? this.createNewChallengeForm.controls.targetType.value : 'SAME_FOR_ALL_PARTICIPANTS';
    this.createNewChallengeForm.value.participantGroup[index].addTargetGroup.forEach((targetData: any) => {
      if (targetType === 'SAME_FOR_ALL_PARTICIPANTS') {
        targetGroupArray.push(this.fb.group({
          id: [null],
          targetGroupName: [targetData.targetGroupName, [Validators.required]],
          eligibleProductSkus: [targetData.eligibleProductSkus],
          eligibleProductSkusNotApplicable: [targetData.eligibleProductSkusNotApplicable],
          eligibleProductFamilies: [targetData.eligibleProductFamilies],
          eligibleProductFamiliesNotApplicable: [targetData.eligibleProductFamiliesNotApplicable],
          setTargets: [null],
          minTargets: [targetData.minTargets, [Validators.required]],
          isOptional: [targetData.isOptional],
          deleted: [false]
        }, { validator: this.skuOrFamilyDataRequired}));
      } else {
        targetGroupArray.push(this.fb.group({
          id: [null],
          targetGroupName: [targetData.targetGroupName, [Validators.required]],
          eligibleProductSkus: [targetData.eligibleProductSkus],
          eligibleProductSkusNotApplicable: [targetData.eligibleProductSkusNotApplicable],
          eligibleProductFamilies: [targetData.eligibleProductFamilies],
          eligibleProductFamiliesNotApplicable: [targetData.eligibleProductFamiliesNotApplicable],
          setTargets: [targetData.setTargets, [Validators.required]],
          minTargets: [null],
          isOptional: [targetData.isOptional],
          deleted: [false]
        }, { validator: this.skuOrFamilyDataRequired}));
      }
    });
    return targetGroupArray;
  };

  removeTargetBlock(i: number, j: number) {
    const participantGroup = <FormArray>this.createNewChallengeForm.get('participantGroup');
    const targetGroup = <FormArray>participantGroup.at(i).get('addTargetGroup');
    const pgList = this.editChallengeData ? this.editChallengeData.productsBookingActChPgList : null;
    if (pgList && pgList[i] && pgList[i].productsBookingActChTargetList[j] && pgList[i].productsBookingActChTargetList[j].id) {
      const deletedControl = targetGroup.at(j).get('deleted');
      if (deletedControl) {
        deletedControl.setValue(true);
      }
    } else {
      targetGroup.removeAt(j);
    }
  };


  addTargetGroup(index: number) {
    const control = <FormArray>(this.createNewChallengeForm.get('participantGroup') as any)['controls'][index].get('addTargetGroup');
    control.push(this.createTargetGroupArray());
  };

  addParticipationGroup() {
    const control = <FormArray>this.createNewChallengeForm.get('participantGroup');
    control.push(this.createParticipantArray());
  };

  submitChallenge() {
    let dupsExist = false;
    if(this.createNewChallengeForm.get('proofofCompletion')!.value){
        dupsExist = this.checkDuplicateDocuments();
    }
    if (dupsExist) {
      this.showDupsError = true;
      return
    } 
    this.showDupsError = false;
    const payload: any = this.createSubmissionPayload()
    payload['creatorType'] = 'CISCO_ADMIN';
    this.managerService.createProductBookingChallenge(payload).subscribe((_data: any) => {
      this.popupMessageService.showSuccess('Product booking created successfully', 'success');
      this.submitStatusEvent.emit(true);
    }, (_err: any) => {
      this.popupMessageService.showError('Something went wrong', 'error');
    });
  };

  updateChallenge() {
    let dupsExist = false;
    if(this.createNewChallengeForm.get('proofofCompletion')!.value){
        dupsExist = this.checkDuplicateDocuments();
    }
    if (dupsExist) {
      this.showDupsError = true;
      return
    } 
    this.showDupsError = false;
    const payload: any = this.createSubmissionPayload()
    payload['id'] = this.editedProductBookingData.id;
    payload['status'] = this.editedProductBookingData.status;
    payload['creatorType'] = this.editedProductBookingData.creatorType;
    this.managerService.createProductBookingChallenge(payload).subscribe((_data: any) => {
      this.popupMessageService.showSuccess('Product booking updated successfully', 'success');
      this.submitStatusEvent.emit(true);
    }, (_err: any) => {
      this.popupMessageService.showError('Something went wrong', 'error');
    });
  }

  createCloneChallenge() {
    let dupsExist = false;
    if(this.createNewChallengeForm.get('proofofCompletion')!.value){
        dupsExist = this.checkDuplicateDocuments();
    }
    if (dupsExist) {
      this.showDupsError = true;
      return
    }
    this.showDupsError = false;
    const payload: any = this.createSubmissionPayload()
    payload['creatorType'] = 'CISCO_ADMIN';
    this.managerService.createProductBookingChallenge(payload).subscribe((_data: any) => {
      this.popupMessageService.showSuccess('Product booking created successfully', 'success');
      this.submitStatusEvent.emit(true);
    }, (_err: any) => {
      this.popupMessageService.showError('Something went wrong', 'error');
    });
  }

  resetChallenge() {
    if (this.editedProductBookingData) {
      this.updateFormWithChallengeData();
    } else {
      this.createProductBookingFormForNew();
    }
  }

  createSubmissionPayload() {
    return {
      name: this.createNewChallengeForm.value.activityName,
      fiscalYear: this.createNewChallengeForm.value.fiscalYear,
      fiscalQuarters: this.createNewChallengeForm.value.fiscalQuarter,
      startDate: this.createNewChallengeForm.getRawValue().startDate,
      completeBy: this.createNewChallengeForm.getRawValue().endDate,
      cutoffDate: this.createNewChallengeForm.getRawValue().cutOffDate,
      acronym: this.createNewChallengeForm.value.acronym,
      challengeIdentifier: null,
      category: "SPECIAL_ACTIVITY",
      description: this.createNewChallengeForm.value.description.replace(/&#160;/g, ""),
      challengeRewards: this.createNewChallengeForm.value.challengeRewards.replace(/&#160;/g, ""),
      participantType: this.createNewChallengeForm.value.participantType,
      rewardType: this.createNewChallengeForm.value.rewardType,
      visibilityEndDate: this.createNewChallengeForm.getRawValue().visibilityEndDate,
      targetType: this.createNewChallengeForm.value.targetType,
      regions: this.createNewChallengeForm.value.assignRegion,
      countries: this.createNewChallengeForm.value.countryList.map((x: any) => x.countryCode),
      roleIds: this.createNewChallengeForm.value.participantType === 'INDIVIDUAL' ? this.createNewChallengeForm.value.assignRole : [],
      beGeoIds: this.createNewChallengeForm.value.partnerCompanies,
      minimumNumberOfPrerequisitesToBeMet: this.createNewChallengeForm.value.minPrerequisitesToBeMet || null,
      requiredPrerequisites:this.createNewChallengeForm.value.preRequisites,
      prerequisitesDTO: this.createNewChallengeForm.value.preRequisites ? this.getPrerequisitesData() : [],
      shouldClaim: this.createNewChallengeForm.value.shouldClaim,
      credits: this.createNewChallengeForm.value.rewardType === 'CREDITS' ? Number(this.createNewChallengeForm.value.rewards) : null,
      points: this.createNewChallengeForm.value.rewardType === 'POINTS' ? Number(this.createNewChallengeForm.value.rewards) : null,
      productsBookingActChPgList: this.getProductsBookingData(),
      managerId: this.userProfile.id,
      typeId: 7,
      typeName: "",
      creditsThatCanBeEarned: 0,
      userIds: [],
      winnersCount: this.createNewChallengeForm.value.rewardsCap,
      visibilities: this.createNewChallengeForm.value.visibility,
      requiredUploadDocuments: this.createNewChallengeForm.value.proofofCompletion,
      documents: this.createNewChallengeForm.value.proofofCompletion ? this.createNewChallengeForm.value.proofOfCompletionGroup.map((x: any) => {
        return {
          id: x.id,
          name: x.proofName,
          requiredApproval: x.proofApproval
        }
      }) : [],
      budgetSource: this.createNewChallengeForm.value.budgetSource,
      budgetCaps: this.getBudgetCapsData(this.createNewChallengeForm.value),
      manualDescription: this.createNewChallengeForm.value.manualDescription?this.createNewChallengeForm.value.manualDescription.replace(/&#160;/g, ""):this.createNewChallengeForm.value.manualDescription,
      scms: this.createNewChallengeForm.value.eligibleScms,
      subScms: this.createNewChallengeForm.value.eligibleSubScms
    }
  };

  getPrerequisitesData() {
    let preRequisites: any[] = []
    this.createNewChallengeForm.value.preRequisitesGroup.forEach((x: any) => {
      if (x.challengeType === 'Activity Challenge') {
        preRequisites.push({
            preqActivityChallengeId: x.activityChallenge,
            optional: x.isOptional
        })
      }
      if (x.challengeType === 'Leaderboard Challenge') {
        preRequisites.push({
            preqLeaderboardChallengeId: x.activityChallenge,
            optional: x.isOptional
        })
      }
    })
    return preRequisites
  };

  getProductsBookingData() {
    const productsBookingData = this.createNewChallengeForm.value.participantGroup.map((group: any, index: number) => {
      return {
        id: group.id,
        name: group.paticipantGroupName,
        minimumNumberOfTargetsToBeAchieved: Number(group.minNoOfTargets), 
        participantBeGeoIds: this.createNewChallengeForm.value.participantType === 'COMPANY' ? group.participantIds : [],
        participantUserIds: this.createNewChallengeForm.value.participantType === 'INDIVIDUAL' ? group.participantIds : [],
        sortOrder: index + 1,
        deleted: group.deleted,
        productsBookingActChTargetList: group.addTargetGroup.map((target: any, tarIndex: number) => {
          return {
            id: target.id,
            name: target.targetGroupName,
            productSkus: target.eligibleProductSkusNotApplicable ? [] : target.eligibleProductSkus,
            productFamilies: target.eligibleProductFamiliesNotApplicable ? [] : target.eligibleProductFamilies,
            targetBooking: this.createNewChallengeForm.value.targetType === 'SAME_FOR_ALL_PARTICIPANTS' ? target.minTargets : "",
            participantTargets: this.createNewChallengeForm.value.targetType === 'PER_PARTICIPANT' ? target.setTargets.map((tar: any) => {
              return {
                beGeoId: this.createNewChallengeForm.value.participantType === 'COMPANY' ? tar.participantId : 0,
                userId: this.createNewChallengeForm.value.participantType === 'INDIVIDUAL' ? tar.participantId : 0,
                targetBooking: tar.target
              }
            }) : [],
            optional: target.isOptional,
            sortOrder: tarIndex + 1,
            deleted: target.deleted,
          }
        })
      }
    })
    return productsBookingData;
  };

  getdocTypeList() {
    this.managerService.getDocTypeList().subscribe((data: any) => {
      console.log('[docTypeList] API response:', data);
      this.docTypeList = data;
    }, (err: any) => {
      console.error('[docTypeList] API error:', err);
      this.popupMessageService.showError('Something went wrong', 'error');
    });
  };

  onProofofCompletionChange(value: boolean) {
    if (value) {
      this.createNewChallengeForm.addControl('proofOfCompletionGroup', this.fb.array([this.createproofOfCompletionArray()]))
      this.manageFilteredOptionsList(0)
    } else {
      this.createNewChallengeForm.removeControl('proofOfCompletionGroup')
    }
  };

  createproofOfCompletionArray() {
    return this.fb.group({
      id: [null],
      proofName: ["", Validators.required],
      proofApproval: [false, Validators.required]
    })
  };

  updateProofOfCompletionArray(documentList: any[]) {
    let updatedArrayList: any[] = [];
    documentList.forEach((proofData: any) => {
      updatedArrayList.push(this.fb.group({
        id: [proofData.id],
        proofName: [proofData.name, Validators.required],
        proofApproval: [proofData.requiredApproval, Validators.required]
      }))
    });
    return updatedArrayList;
  };

  getProofOfCompletionGroup(form: any) {
    return form.controls.proofOfCompletionGroup.controls;
  };

  addProofOfCompletionGroup() {
    const control = <FormArray>this.createNewChallengeForm.get('proofOfCompletionGroup');
    control.push(this.createproofOfCompletionArray());
    this.manageFilteredOptionsList(control.length - 1)
  };

  removeProofOfCompletionGroup(index: number) {
    const control = <FormArray>this.createNewChallengeForm.get('proofOfCompletionGroup');
    control.removeAt(index)
    this.filteredOptions.splice(index, 1);
  };

  manageFilteredOptionsList(index: number) {
    console.log('[manageFilteredOptionsList] index:', index, '| docTypeList at setup time:', this.docTypeList);
    const arrayControl = this.createNewChallengeForm.get('proofOfCompletionGroup') as FormArray;
    this.filteredOptions[index] = arrayControl.at(index).get('proofName')!.valueChanges.pipe(
      startWith<any>(''),
      map((value: any) => {
        console.log('[proofName valueChange] raw value:', value);
        return typeof value === 'string' ? value : value.name;
      }),
      map((name: any) => {
        const results = name ? this._filter(name) : this.docTypeList.slice();
        console.log('[proofName filter] name:', name, '| results:', results);
        return results;
      })
    );
  };

  private _filter(name: string) {
    const filterValue = name.toLowerCase();
    return this.docTypeList.filter((option: any) => option.name.toLowerCase().indexOf(filterValue) === 0);
  };

  displayFn(option: any): string | undefined {
    return option ? (typeof(option) === 'string' ? option : option.name) : undefined;
  };

  checkDuplicateDocuments() {
    let dupsExist = false;
    const documentsList = this.createNewChallengeForm.get('proofOfCompletionGroup')!.value.map((x: any) => x.proofName);
    if (new Set(documentsList).size !== documentsList.length) {
      dupsExist = true;
    }
    return dupsExist;
  };
  addBudgetCapPerRegionGroup(region: string) {
    return this.fb.group({
      region: [region],
      budgetCap: ['', [Validators.required, Validators.pattern(CONSTANTS.regex.notZero)]],
      createdBy: [''],
      id: [''],
      modifiedBy: ['']
    })
  };

  updateBudgetCapPerRegionGroup(budget: any) {
    return this.fb.group({
      region: [budget.region],
      budgetCap: [budget.amount, [Validators.required, Validators.pattern(CONSTANTS.regex.notZero)]],
      createdBy: [budget.createdBy],
      id: [budget.id],
      modifiedBy: ['']
    })
  };

  get budgetCapByRegionGroupArray(): FormArray {
    return <FormArray>this.createNewChallengeForm.get('budgetCapByRegionGroup');
  };

  setBudgetCapData(res: any) {
    let budgetData: any[] = []
    if (res.rewardType === 'POINTS') {
      res.budgetCaps.forEach((budget: any) => {
        budgetData.push(this.updateBudgetCapPerRegionGroup(budget));
      })
    }
    return budgetData
  };

  getBudgetCapsData(formData: any) {
    let budgetCapData: any[] = [];
    if (formData.rewardType === 'POINTS') {
      budgetCapData = formData.budgetCapByRegionGroup.map((budgetRegion: any) => {
        return {
          activityBudgetCapType: "BUDGETCAP_REGIONAL",
          amount: budgetRegion.budgetCap,
          region: budgetRegion.region,
          id: budgetRegion.id || '',
          createdBy: budgetRegion.createdBy || this.userProfile.id,
          modifiedBy: this.editChallengeData ? this.userProfile.id : ''
        }
      })
    }
    return budgetCapData;
  };

  onRegionSelection() {
    if (this.createNewChallengeForm.controls.rewardType.value === 'POINTS') {
      const assignRegionControl = this.createNewChallengeForm.get('assignRegion');
      const selectedRegions: any[] = assignRegionControl ? assignRegionControl.value || [] : [];
      this.regionsList.forEach((region: any) => {
        const index = this.budgetCapByRegionGroupArray.value.findIndex((budget: any) => budget.region === region);
        const isSelected = selectedRegions.indexOf(region) > -1;
        if (isSelected && index === -1) {
          this.budgetCapByRegionGroupArray.push(this.addBudgetCapPerRegionGroup(region));
        }
        if (!isSelected && index > -1) {
          this.budgetCapByRegionGroupArray.removeAt(index);
        }
      });

      this.createNewChallengeForm.get('budgetSource')!.setValidators([Validators.required]);
      this.createNewChallengeForm.get('budgetSource')!.updateValueAndValidity();
    } else {
      this.createNewChallengeForm.get('budgetSource')!.setValue(null);
      this.createNewChallengeForm.get('budgetSource')!.clearValidators();
      this.createNewChallengeForm.get('budgetSource')!.updateValueAndValidity();
      while (this.budgetCapByRegionGroupArray.value.length) {
        this.budgetCapByRegionGroupArray.removeAt(0);
      }
    }
  };
  editorConfig: AngularEditorConfig = {
    editable: true,
      spellcheck: true,
      height: '150px',
      minHeight: '0',
      maxHeight: 'auto',
      width: '350px',
      minWidth: '0',
      translate: 'yes',
      enableToolbar: true,
      showToolbar: true,
      placeholder: 'Enter text here...',
      defaultParagraphSeparator: '',
      defaultFontName: '',
      defaultFontSize: '',
    sanitize: true,
    toolbarPosition: 'top',

};
rewardEditorConfig: AngularEditorConfig = {
  editable: true,
    spellcheck: true,
    height: '97px',
    minHeight: '0',
    maxHeight: 'auto',
    width: '354px',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
  sanitize: true,
  toolbarPosition: 'top',

};
  updatePreRequisites(data: any[]) {
    let updatedPrerequisites: any[] = []
    data.forEach((ele: any) => {
      updatedPrerequisites.push(this.fb.group({
        challengeType: ['Activity Challenge', Validators.required],
        activityChallenge: [ele.preqActivityChallengeId, Validators.required],
        isOptional: [ele.optional, Validators.required]
      }));
    })
    return updatedPrerequisites;
  }
  setChallengeDropdownData(data: any[]) {
    data.forEach((ele: any, index: number) => {
      this.onChallengeTypeChange(ele,index)
    })
  }
  onActivityTypeChange(item: any, index: number): void {
    const selectedId = item ? item.id : '';
    (this.createNewChallengeForm.controls.preRequisitesGroup as any)['controls'][index].controls['activityChallenge'].setValue(selectedId);
    const checkDuplicateObj = this.createNewChallengeForm.value.preRequisitesGroup.filter((x: any, grpIndex: number) => (
      (x.activityChallenge === selectedId) && (this.selectedChallengeType === x.challengeType) && grpIndex !== index
    ));
    if (checkDuplicateObj.length > 0) {
      this.prereqActivityChallengeFlag = true;
      (this.createNewChallengeForm.controls.preRequisitesGroup as any)['controls'][index].controls['activityChallenge'].setValue('');
    } else {
      this.prereqActivityChallengeFlag = false;
    }
  }

  getSelectedActivityItem(pr: number): any {
    const control = this.createNewChallengeForm.controls.preRequisitesGroup;
    if (!control) { return null; }
    const group = (control as any)['controls'][pr];
    if (!group) { return null; }
    const selectedId = group.get('activityChallenge')!.value;
    if (!selectedId || !this.activityDropdownList[pr]) { return null; }
    const found = this.activityDropdownList[pr].filter((item: any) => item.id === selectedId);
    return found.length > 0 ? found[0] : null;
  }
  checkInactiveStatus(){
    const q = new Date();
    const m = q.getMonth();
    const d = q.getDate();
    const y = q.getFullYear();

    const todayDate = new Date(y,m,d);

    const mydate=new Date(this.editChallengeData.completeBy);


    if((todayDate>mydate)&&this.editChallengeData.status==='INACTIVE')
    {
      this.readonlyFlag=true;
    }else{
      this.readonlyFlag=false;
    }

    this.applyDateControlsDisabledState();
  }

  applyDateControlsDisabledState() {
    if (!this.createNewChallengeForm) { return; }
    const dateControls = ['startDate', 'endDate', 'cutOffDate', 'visibilityEndDate'];
    dateControls.forEach(name => {
      const control = this.createNewChallengeForm.get(name);
      if (control) {
        if (this.readonlyFlag) {
          control.disable({ emitEvent: false });
        } else {
          control.enable({ emitEvent: false });
        }
      }
    });
  }
}
